import { __assign } from "tslib";
import React from 'react';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
// eslint-disable-next-line no-unused-vars
import moment from 'moment';
export var DatePicker = function (options) {
    var convertDateToParsableDate = function (value, format) {
        return moment(value, format).format('MM-DD-YYYY');
    };
    return (React.createElement(MuiPickersUtilsProvider, { utils: MomentUtils },
        React.createElement(KeyboardDatePicker, __assign({}, options.props, { format: options.format, onChange: function (date, value) {
                !options.disabled && options.onChange && options.onChange(value);
            }, label: options.label, disabled: options.disabled, value: options.value && convertDateToParsableDate(options.value, options.format), maxDate: options.maxDate, minDate: options.minDate, "data-testid": options.testId, className: options.className, maxDateMessage: options.maxDateMessage, minDateMessage: options.minDateMessage, invalidDateMessage: options.invalidDateMessage, invalidLabel: options.invalidLabel }))));
};
//# sourceMappingURL=DatePicker.js.map